/**
 * Returns whether a treatment plan meets the comment box approval criteria.
 */
export const canApproveTreatmentPlan = ({ planId = 0, treatmentPlans = [], caseStatus }) => {
    if (!planId || !treatmentPlans.length) return false;

    const isStatusAllowApproval = ['PLAN_UPLOADED', 'UPGRADE_REQUEST', 'DEFECT_RESPONDED', 'SUBMITTED'].includes(
        caseStatus
    );

    if (!isStatusAllowApproval) return false;

    for (let index = 0; index < treatmentPlans.length; index++) {
        const planList = treatmentPlans[index];
        const matchPlan = planList.find((plan) => plan.plan_id === planId);
        if (matchPlan) {
            return !matchPlan.approved_flag && planList.every((plan) => plan.approved_flag === false);
        }
    }

    return false;
};
